import Cookies from 'js-cookie';
import { clearCache } from 'services/swr';

export const signIn = () => {
    if (typeof window !== 'undefined') {
        Cookies.set('__Host-opswat-redirect', window.location.href, { secure: true, path: '/' });
        window.location.href = '/login?commercial';
    }
};

export const signOut = async () => {
    await clearCache();
    window.location.href = '/logout';
};

export const clearRedirectCookie = () => {
    if (typeof window !== 'undefined') {
        Cookies.set('__Host-opswat-redirect', '', { secure: true, path: '/' });
    }
};

export const generateFingerPrint = async () => {
    const { default: FingerprintJS } = await import('@fingerprintjs/fingerprintjs');
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    const apikey = result.visitorId;

    if (!apikey) {
        throw new Error('Failed to generate a fingerprint');
    }
    return apikey;
};

export const b64DecodeUnicode = (input: string) => {
    return decodeURIComponent(
        Array.prototype.map
            .call(atob(input), (c) => {
                return '%' + ('00' + (c.codePointAt(0) ?? 0).toString(16)).slice(-2);
            })
            .join(''),
    );
};
